export const MARKER_INDEX_MAX = 20;
/**
 * Returns the name of the svg icon to use for the given index.
 * If the index is greater than the max index, returns the name of the "AddCircleFilled" icon.
 **/
export const getNumOutlinedSvgIconName = (index: number): `Num${number}Outlined` | 'AddCircleFilled' =>
  index < MARKER_INDEX_MAX ? `Num${index + 1}Outlined` : 'AddCircleFilled';
